import { DisplayFiltersAction, HideFiltersAction } from './types';

export const displayFiltersAction = 'process/DISPLAY_FILTERS';
export const hideFiltersAction = 'process/HIDE_FILTERS';

export const displayFilters = (): DisplayFiltersAction => ({
    type: displayFiltersAction,
});

export const hideFilters = (): HideFiltersAction => ({
    type: hideFiltersAction,
});
